module.exports = __webpack_public_path__ + "img/painted-phone-case.8cdc26e7.jpg";